"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const functions_1 = require("./functions");
exports.AccountId = functions_1.Ref('AWS::AccountId');
exports.NotificationARNs = functions_1.Ref("AWS::NotificationARNs");
exports.NoValue = functions_1.Ref('AWS::NoValue');
exports.Partition = functions_1.Ref('AWS::Partition');
exports.Region = functions_1.Ref('AWS::Region');
exports.StackId = functions_1.Ref('AWS::StackId');
exports.StackName = functions_1.Ref('AWS::StackName');
exports.URLSuffix = functions_1.Ref('AWS::URLSuffix');
